// Copyright (c) 2019 Deere & Company

const allowedFormatKeys = ['1', '2', '3', '4', '5', '6'];

const dateFormats = {
    1: 'DD.MM.YYYY',
    2: 'MM/DD/YYYY',
    3: 'MM-DD-YYYY',
    4: 'YYYY.MM.DD',
    5: 'YYYY/MM/DD',
    6: 'YYYY-MM-DD',
};

export const getDateFormat = (formatKey) => formatKey && allowedFormatKeys.includes(formatKey) ? dateFormats[formatKey] : 'MM/DD/YYYY';
